import * as Yup from 'yup';

import { LoginForm, LoginFormFieldNames } from './types';

export const LOGIN_FORM_INITIAL_VALUES: LoginForm = {
  email: '',
  password: '',
};

export const EMAIL: LoginFormFieldNames = 'email';
export const PASSWORD: LoginFormFieldNames = 'password';

export const LoginFormValidationSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Enter your email address.'),
  password: Yup.string().min(8, 'Password must be at least 8 characters').required('A valid password is required.'),
});
